<template>
    <div>
        <!--
          Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
          Read the documentation to get started: https://tailwindui.com/documentation
        -->
        <fieldset class="m-0 px-0">
            <legend class="sr-only">
                Permission Level
            </legend>

            <div class="bg-white rounded-md -space-y-px grid grid-cols-1 ">
                <!-- On: "bg-blue-50 border-blue-200 z-10", Off: "border-gray-200" -->
                <div    v-for="(info) in permissionLevels"
                        class="">
                    <div    class="cursor-pointer flex items-start my-2 relative border rounded-md p-4"
                            :class="[modelValue === info.name ? 'bg-blue-50 border-blue-200 z-10' : 'border-gray-200']"
                            @click="setPermission(info.name)">
                        <div class="flex items-center h-5">
                            <input :id="`permission-${info.name}`" name="privacy_setting"
                                   class="h-4 w-4 text-blue-600 cursor-pointer"
                                   :checked="modelValue === info.name"
                                   type="radio"
                            >
                        </div>
                        <label :id="`permission-${info.name}`" class="ml-3 flex flex-col cursor-pointer">
                            <!-- On: "text-blue-900", Off: "text-gray-900" -->
                            <span   class="block text-sm leading-5 font-medium"
                                    :class="[modelValue === info.name ? 'text-blue-900' : 'text-gray-900']">
                            {{ info.displayName }}
                        </span>
                            <!-- On: "text-blue-700", Off: "text-gray-500" -->
                            <span   class="block text-sm leading-5"
                                    :class="[modelValue === info.name ? 'text-blue-700' : 'text-gray-500']">
                            {{ info.description }}
                        </span>
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>


import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "PermissionLevelRadio",
    compatConfig: { COMPONENT_V_MODEL: false },
    emits: ['update:modelValue'],
    mixins: [iconNamesMixin],
    components: {},
    props: {
        permissionLevels: [Array, Object],
        modelValue: String,
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        setPermission(permissionName) {
            this.$emit('update:modelValue', permissionName)
        }
    },
    computed: {

    },
    watch: {

    },
}

</script>

<style scoped>

</style>